import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Menu.css';


function Navbar() {
    let [works, setWorks] = useState(['Vanished Fantasy', 'Space Out', 'Proto Carbon']);
    let [commissions, setCommissions] = useState(['Collectors Words', 'Seoul 2121']);

    return (
        <div>
            <div className='menu'>
                <Link to="/"><h3>Sima Kim</h3></Link>
                <hr />

                <Link to="/spaceout"><h4>{works[1]}</h4></Link>
                <Link to="/vanishedfantasy"><h4>{works[0]}</h4></Link>

                <hr />
                <Link to="/seoul2121"><h4>{commissions[1]}</h4></Link>
                <Link to="/collectorswords"><h4>{commissions[0]}</h4></Link>

                <hr />
                <Link to="/info"><h4>info</h4></Link>

                <hr />
                <h4 onClick={() => window.open('http://simakim.bandcamp.com', '_blank')}>Music</h4>
    
            </div>


        </div>
    )
}

export default Navbar;